import { createContext } from '@lit/context';
import { ContentDeliveryClient } from '../clients/content-delivery-client';

export const contentDeliveryClientContext = createContext<ContentDeliveryClient>(Symbol('content-delivery-client'));
